// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserDetail_page__jM8vY {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.UserDetail_topGrid__Hnm4B,
.UserDetail_bottomGrid__fTxXo {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  align-items: start;
}

.UserDetail_cardTitle__jd7Jd {
  font-size: 24px;
  font-weight: 700;
  color: var(--dylo-ink);
  margin: 0 0 18px;
}

/* ===== Users Details ===== */
.UserDetail_detailGrid__2GC-- {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 20px;
}
.UserDetail_detailField__T7mLz {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.UserDetail_detailLabel__vgV4l {
  font-size: 13px;
  font-weight: 600;
  color: var(--dylo-text);
}

.UserDetail_statusPill__a\\+eOV {
  align-self: flex-start;
  min-width: 110px;
  padding: 9px 16px;
  border-radius: 999px;
  font-size: 12.5px;
  font-weight: 700;
  letter-spacing: 0.4px;
  cursor: pointer;
  transition: filter 0.15s ease;
}
.UserDetail_statusPill__a\\+eOV:disabled {
  cursor: default;
}
.UserDetail_statusPill__a\\+eOV:not(:disabled):hover {
  filter: brightness(1.08);
}
.UserDetail_active__1NaiY {
  color: #2aad27;
  background: color-mix(in srgb, #2aad27 14%, transparent);
  border: 1px solid color-mix(in srgb, #2aad27 45%, transparent);
}
.UserDetail_inactive__K1XDq {
  color: var(--dylo-danger);
  background: color-mix(in srgb, var(--dylo-danger) 14%, transparent);
  border: 1px solid color-mix(in srgb, var(--dylo-danger) 45%, transparent);
}

.UserDetail_detailActions__1wxI1 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 20px;
}
.UserDetail_pwBtn__\\+0glj {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #1f1f1f !important;
  color: #fff !important;
  border: none !important;
}
.UserDetail_pwBtn__\\+0glj:hover {
  background: #000 !important;
}
.UserDetail_updateBtn__\\+oqZN {
  background: var(--dylo-orange) !important;
  border: none !important;
}
.UserDetail_updateBtn__\\+oqZN:hover {
  background: var(--dylo-orange-hover) !important;
}

/* ===== Permissions tree ===== */
.UserDetail_permTree__pNxEN {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.UserDetail_permNode__guk7E {
  display: flex;
  flex-direction: column;
}
.UserDetail_permRow__\\+uSO8 {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 4px;
  border-radius: 8px;
}
.UserDetail_permRow__\\+uSO8:hover {
  background: color-mix(in srgb, var(--dylo-teal-700) 7%, transparent);
}
.UserDetail_permChevron__OXpjT {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: none;
  background: transparent;
  color: var(--dylo-muted);
  cursor: pointer;
  border-radius: 5px;
  transition: transform 0.15s ease, color 0.15s ease;
}
.UserDetail_permChevronOpen__LtPMC {
  transform: rotate(90deg);
  color: var(--dylo-ink);
}
.UserDetail_permChevronSpacer__tAVfF {
  width: 20px;
  flex-shrink: 0;
}
.UserDetail_permLabel__4KlmN {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 13.5px;
  color: var(--dylo-ink);
  min-width: 0;
}
.UserDetail_permCheckboxNative__DVyq0 {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.UserDetail_permBox__LsMPq {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 17px;
  height: 17px;
  flex-shrink: 0;
  border-radius: 5px;
  border: 1.5px solid var(--dylo-field-border);
  color: #fff;
  transition: background 0.14s ease, border-color 0.14s ease;
}
.UserDetail_permBoxChecked__MFVgk {
  background: #2aad27;
  border-color: #2aad27;
}
.UserDetail_permName__PeoIM {
  font-weight: 600;
}
.UserDetail_permDesc__gKky3 {
  color: var(--dylo-muted);
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.UserDetail_permBadge__iaMI4 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: #2aad27;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
}
.UserDetail_permChildren__w\\+SuO {
  display: flex;
  flex-direction: column;
  gap: 2px;
  animation: UserDetail_dylo-fade-in__wU5TH 0.2s ease both;
}
.UserDetail_permSelectAllRow__j7nVw {
  display: flex;
  justify-content: flex-end;
  padding: 2px 4px 6px;
}
.UserDetail_permSelectAll__fEZDw {
  border: none;
  background: transparent;
  color: var(--dylo-teal-700);
  font-family: var(--font-sans);
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
  padding: 3px 6px;
  border-radius: 6px;
}
.UserDetail_permSelectAll__fEZDw:hover {
  background: color-mix(in srgb, var(--dylo-teal-700) 12%, transparent);
}
.UserDetail_permSelectAllActive__JATnc {
  color: var(--dylo-danger);
}
.UserDetail_permSelectAllActive__JATnc:hover {
  background: color-mix(in srgb, var(--dylo-danger) 12%, transparent);
}
.UserDetail_permEmpty__fU3p6 {
  font-size: 13px;
  color: var(--dylo-muted);
  margin: 0;
}

/* ===== Clients / Deliveries lists ===== */
.UserDetail_listHead__EFWFM {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.UserDetail_listTitle__eQQ7A {
  font-size: 16px;
  font-weight: 700;
  color: var(--dylo-ink);
  margin: 0;
}
.UserDetail_assignBtn__cSW9z {
  background: var(--dylo-teal-700) !important;
  color: #fff !important;
  border: none !important;
  font-size: 12.5px !important;
  padding: 7px 12px !important;
}
.UserDetail_searchBox__TCsa4 {
  margin-bottom: 12px;
}
.UserDetail_assignList__9Kk2G {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 340px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: color-mix(in srgb, var(--dylo-muted) 35%, transparent) transparent;
}
.UserDetail_assignList__9Kk2G::-webkit-scrollbar {
  width: 6px;
}
.UserDetail_assignList__9Kk2G::-webkit-scrollbar-thumb {
  background: color-mix(in srgb, var(--dylo-muted) 35%, transparent);
  border-radius: 3px;
}
.UserDetail_assignRow__LP7Ie {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid var(--dylo-line);
  border-radius: 12px;
  animation: UserDetail_dylo-fade-in__wU5TH 0.24s ease both;
}
.UserDetail_assignName__ZXLCp {
  font-size: 13px;
  color: var(--dylo-ink);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.UserDetail_rowRight__c3Ne5 {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.UserDetail_miniPill__qC2-H {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
}
.UserDetail_pillActive__\\+0SFT {
  color: #2aad27;
  background: color-mix(in srgb, #2aad27 12%, transparent);
  border: 1px solid color-mix(in srgb, #2aad27 45%, transparent);
}
.UserDetail_unassignBtn__2u2Y4 {
  padding: 4px 12px;
  border-radius: 999px;
  border: 1px solid color-mix(in srgb, var(--dylo-danger) 45%, transparent);
  background: transparent;
  color: var(--dylo-danger);
  font-family: var(--font-sans);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  cursor: pointer;
  transition: background 0.14s ease;
}
.UserDetail_unassignBtn__2u2Y4:hover:not(:disabled) {
  background: color-mix(in srgb, var(--dylo-danger) 12%, transparent);
}
.UserDetail_unassignBtn__2u2Y4:disabled {
  opacity: 0.5;
  cursor: default;
}
.UserDetail_listEmpty__VD48K {
  font-size: 13px;
  color: var(--dylo-muted);
  text-align: center;
  padding: 24px;
  margin: 0;
}

/* ===== Modals ===== */
.UserDetail_assignModalList__uD2uX {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 400px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: color-mix(in srgb, var(--dylo-muted) 35%, transparent) transparent;
}
.UserDetail_assignSelectAll__ebn3g {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  padding: 6px 4px;
  border: none;
  background: transparent;
  color: var(--dylo-ink);
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.UserDetail_assignPickRow__QtNEW {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 14px;
  border: 1px solid var(--dylo-line);
  border-radius: 12px;
  background: transparent;
  color: var(--dylo-ink);
  font-family: var(--font-sans);
  text-align: left;
  cursor: pointer;
  transition: border-color 0.14s ease, background 0.14s ease;
}
.UserDetail_assignPickRow__QtNEW:hover {
  border-color: var(--dylo-teal-500);
  background: color-mix(in srgb, var(--dylo-teal-700) 6%, transparent);
}
.UserDetail_assignCheck__L1Q\\+q {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  border-radius: 5px;
  border: 1.5px solid var(--dylo-field-border);
  color: #fff;
  transition: background 0.14s ease, border-color 0.14s ease;
}
.UserDetail_assignCheckOn__qZDAy {
  background: var(--dylo-teal-700);
  border-color: var(--dylo-teal-700);
}
.UserDetail_pwForm__tBiJC {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.UserDetail_pwField__Mclny {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.UserDetail_pwError__1iKj8 {
  color: var(--dylo-danger);
  font-size: 12.5px;
}

/* ===== Skeleton ===== */
.UserDetail_skTitle__mLXGk {
  margin-bottom: 18px !important;
}
.UserDetail_skRounded__dRyIn {
  border-radius: 10px !important;
}
.UserDetail_skBox__5kmOY {
  border-radius: 5px !important;
}
.UserDetail_skPermList__lUJgl {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.UserDetail_skPermRow__T8blN {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 0;
}
.UserDetail_skRows__I3FM1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 12px;
}
.UserDetail_skListRow__dro3k {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border: 1px solid var(--dylo-line);
  border-radius: 12px;
}

/* \`minmax(0, 1fr)\` y no \`1fr\` (26-oct-2026): con \`1fr\` la columna no baja del ancho mínimo de un campo, que en el
   iPhone es más ancho que en Chromium, y la forma se salía de la tarjeta (lo que le pasaba al login). */
@media (max-width: 1000px) {
  .UserDetail_topGrid__Hnm4B,
  .UserDetail_bottomGrid__fTxXo {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 560px) {
  .UserDetail_detailGrid__2GC--,
  .UserDetail_detailActions__1wxI1 {
    grid-template-columns: minmax(0, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/UserDetail/UserDetail.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,wDAAwD;EACxD,8DAA8D;AAChE;AACA;EACE,yBAAyB;EACzB,mEAAmE;EACnE,yEAAyE;AAC3E;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yCAAyC;EACzC,uBAAuB;AACzB;AACA;EACE,+CAA+C;AACjD;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,oEAAoE;AACtE;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,kDAAkD;AACpD;AACA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,4CAA4C;EAC5C,WAAW;EACX,0DAA0D;AAC5D;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,wDAAsC;AACxC;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,qEAAqE;AACvE;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mEAAmE;AACrE;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,SAAS;AACX;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,2CAA2C;EAC3C,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,mFAAmF;AACrF;AACA;EACE,UAAU;AACZ;AACA;EACE,kEAAkE;EAClE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,yDAAuC;AACzC;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,wDAAwD;EACxD,8DAA8D;AAChE;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,yEAAyE;EACzE,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,mEAAmE;AACrE;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,mFAAmF;AACrF;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;AACA;EACE,kCAAkC;EAClC,oEAAoE;AACtE;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,4CAA4C;EAC5C,WAAW;EACX,0DAA0D;AAC5D;AACA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;wGACwG;AACxG;EACE;;IAEE,qCAAqC;EACvC;AACF;AACA;EACE;;IAEE,qCAAqC;EACvC;AACF","sourcesContent":[".page {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.topGrid,\n.bottomGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  align-items: start;\n}\n\n.cardTitle {\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--dylo-ink);\n  margin: 0 0 18px;\n}\n\n/* ===== Users Details ===== */\n.detailGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px 20px;\n}\n.detailField {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n.detailLabel {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--dylo-text);\n}\n\n.statusPill {\n  align-self: flex-start;\n  min-width: 110px;\n  padding: 9px 16px;\n  border-radius: 999px;\n  font-size: 12.5px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  cursor: pointer;\n  transition: filter 0.15s ease;\n}\n.statusPill:disabled {\n  cursor: default;\n}\n.statusPill:not(:disabled):hover {\n  filter: brightness(1.08);\n}\n.active {\n  color: #2aad27;\n  background: color-mix(in srgb, #2aad27 14%, transparent);\n  border: 1px solid color-mix(in srgb, #2aad27 45%, transparent);\n}\n.inactive {\n  color: var(--dylo-danger);\n  background: color-mix(in srgb, var(--dylo-danger) 14%, transparent);\n  border: 1px solid color-mix(in srgb, var(--dylo-danger) 45%, transparent);\n}\n\n.detailActions {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-top: 20px;\n}\n.pwBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: #1f1f1f !important;\n  color: #fff !important;\n  border: none !important;\n}\n.pwBtn:hover {\n  background: #000 !important;\n}\n.updateBtn {\n  background: var(--dylo-orange) !important;\n  border: none !important;\n}\n.updateBtn:hover {\n  background: var(--dylo-orange-hover) !important;\n}\n\n/* ===== Permissions tree ===== */\n.permTree {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.permNode {\n  display: flex;\n  flex-direction: column;\n}\n.permRow {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 4px;\n  border-radius: 8px;\n}\n.permRow:hover {\n  background: color-mix(in srgb, var(--dylo-teal-700) 7%, transparent);\n}\n.permChevron {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border: none;\n  background: transparent;\n  color: var(--dylo-muted);\n  cursor: pointer;\n  border-radius: 5px;\n  transition: transform 0.15s ease, color 0.15s ease;\n}\n.permChevronOpen {\n  transform: rotate(90deg);\n  color: var(--dylo-ink);\n}\n.permChevronSpacer {\n  width: 20px;\n  flex-shrink: 0;\n}\n.permLabel {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 13.5px;\n  color: var(--dylo-ink);\n  min-width: 0;\n}\n.permCheckboxNative {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n.permBox {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 17px;\n  height: 17px;\n  flex-shrink: 0;\n  border-radius: 5px;\n  border: 1.5px solid var(--dylo-field-border);\n  color: #fff;\n  transition: background 0.14s ease, border-color 0.14s ease;\n}\n.permBoxChecked {\n  background: #2aad27;\n  border-color: #2aad27;\n}\n.permName {\n  font-weight: 600;\n}\n.permDesc {\n  color: var(--dylo-muted);\n  font-size: 12px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.permBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  border-radius: 9px;\n  background: #2aad27;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n.permChildren {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  animation: dylo-fade-in 0.2s ease both;\n}\n.permSelectAllRow {\n  display: flex;\n  justify-content: flex-end;\n  padding: 2px 4px 6px;\n}\n.permSelectAll {\n  border: none;\n  background: transparent;\n  color: var(--dylo-teal-700);\n  font-family: var(--font-sans);\n  font-size: 11.5px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 3px 6px;\n  border-radius: 6px;\n}\n.permSelectAll:hover {\n  background: color-mix(in srgb, var(--dylo-teal-700) 12%, transparent);\n}\n.permSelectAllActive {\n  color: var(--dylo-danger);\n}\n.permSelectAllActive:hover {\n  background: color-mix(in srgb, var(--dylo-danger) 12%, transparent);\n}\n.permEmpty {\n  font-size: 13px;\n  color: var(--dylo-muted);\n  margin: 0;\n}\n\n/* ===== Clients / Deliveries lists ===== */\n.listHead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n.listTitle {\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--dylo-ink);\n  margin: 0;\n}\n.assignBtn {\n  background: var(--dylo-teal-700) !important;\n  color: #fff !important;\n  border: none !important;\n  font-size: 12.5px !important;\n  padding: 7px 12px !important;\n}\n.searchBox {\n  margin-bottom: 12px;\n}\n.assignList {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-height: 340px;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: color-mix(in srgb, var(--dylo-muted) 35%, transparent) transparent;\n}\n.assignList::-webkit-scrollbar {\n  width: 6px;\n}\n.assignList::-webkit-scrollbar-thumb {\n  background: color-mix(in srgb, var(--dylo-muted) 35%, transparent);\n  border-radius: 3px;\n}\n.assignRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 14px;\n  border: 1px solid var(--dylo-line);\n  border-radius: 12px;\n  animation: dylo-fade-in 0.24s ease both;\n}\n.assignName {\n  font-size: 13px;\n  color: var(--dylo-ink);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.rowRight {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n.miniPill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px 12px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n}\n.pillActive {\n  color: #2aad27;\n  background: color-mix(in srgb, #2aad27 12%, transparent);\n  border: 1px solid color-mix(in srgb, #2aad27 45%, transparent);\n}\n.unassignBtn {\n  padding: 4px 12px;\n  border-radius: 999px;\n  border: 1px solid color-mix(in srgb, var(--dylo-danger) 45%, transparent);\n  background: transparent;\n  color: var(--dylo-danger);\n  font-family: var(--font-sans);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n  cursor: pointer;\n  transition: background 0.14s ease;\n}\n.unassignBtn:hover:not(:disabled) {\n  background: color-mix(in srgb, var(--dylo-danger) 12%, transparent);\n}\n.unassignBtn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n.listEmpty {\n  font-size: 13px;\n  color: var(--dylo-muted);\n  text-align: center;\n  padding: 24px;\n  margin: 0;\n}\n\n/* ===== Modals ===== */\n.assignModalList {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-height: 400px;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: color-mix(in srgb, var(--dylo-muted) 35%, transparent) transparent;\n}\n.assignSelectAll {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n  padding: 6px 4px;\n  border: none;\n  background: transparent;\n  color: var(--dylo-ink);\n  font-family: var(--font-sans);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.assignPickRow {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 12px 14px;\n  border: 1px solid var(--dylo-line);\n  border-radius: 12px;\n  background: transparent;\n  color: var(--dylo-ink);\n  font-family: var(--font-sans);\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.14s ease, background 0.14s ease;\n}\n.assignPickRow:hover {\n  border-color: var(--dylo-teal-500);\n  background: color-mix(in srgb, var(--dylo-teal-700) 6%, transparent);\n}\n.assignCheck {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  border-radius: 5px;\n  border: 1.5px solid var(--dylo-field-border);\n  color: #fff;\n  transition: background 0.14s ease, border-color 0.14s ease;\n}\n.assignCheckOn {\n  background: var(--dylo-teal-700);\n  border-color: var(--dylo-teal-700);\n}\n.pwForm {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n.pwField {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.pwError {\n  color: var(--dylo-danger);\n  font-size: 12.5px;\n}\n\n/* ===== Skeleton ===== */\n.skTitle {\n  margin-bottom: 18px !important;\n}\n.skRounded {\n  border-radius: 10px !important;\n}\n.skBox {\n  border-radius: 5px !important;\n}\n.skPermList {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.skPermRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 4px 0;\n}\n.skRows {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 12px;\n}\n.skListRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 14px;\n  border: 1px solid var(--dylo-line);\n  border-radius: 12px;\n}\n\n/* `minmax(0, 1fr)` y no `1fr` (26-oct-2026): con `1fr` la columna no baja del ancho mínimo de un campo, que en el\n   iPhone es más ancho que en Chromium, y la forma se salía de la tarjeta (lo que le pasaba al login). */\n@media (max-width: 1000px) {\n  .topGrid,\n  .bottomGrid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n@media (max-width: 560px) {\n  .detailGrid,\n  .detailActions {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `UserDetail_page__jM8vY`,
	"topGrid": `UserDetail_topGrid__Hnm4B`,
	"bottomGrid": `UserDetail_bottomGrid__fTxXo`,
	"cardTitle": `UserDetail_cardTitle__jd7Jd`,
	"detailGrid": `UserDetail_detailGrid__2GC--`,
	"detailField": `UserDetail_detailField__T7mLz`,
	"detailLabel": `UserDetail_detailLabel__vgV4l`,
	"statusPill": `UserDetail_statusPill__a+eOV`,
	"active": `UserDetail_active__1NaiY`,
	"inactive": `UserDetail_inactive__K1XDq`,
	"detailActions": `UserDetail_detailActions__1wxI1`,
	"pwBtn": `UserDetail_pwBtn__+0glj`,
	"updateBtn": `UserDetail_updateBtn__+oqZN`,
	"permTree": `UserDetail_permTree__pNxEN`,
	"permNode": `UserDetail_permNode__guk7E`,
	"permRow": `UserDetail_permRow__+uSO8`,
	"permChevron": `UserDetail_permChevron__OXpjT`,
	"permChevronOpen": `UserDetail_permChevronOpen__LtPMC`,
	"permChevronSpacer": `UserDetail_permChevronSpacer__tAVfF`,
	"permLabel": `UserDetail_permLabel__4KlmN`,
	"permCheckboxNative": `UserDetail_permCheckboxNative__DVyq0`,
	"permBox": `UserDetail_permBox__LsMPq`,
	"permBoxChecked": `UserDetail_permBoxChecked__MFVgk`,
	"permName": `UserDetail_permName__PeoIM`,
	"permDesc": `UserDetail_permDesc__gKky3`,
	"permBadge": `UserDetail_permBadge__iaMI4`,
	"permChildren": `UserDetail_permChildren__w+SuO`,
	"dylo-fade-in": `UserDetail_dylo-fade-in__wU5TH`,
	"permSelectAllRow": `UserDetail_permSelectAllRow__j7nVw`,
	"permSelectAll": `UserDetail_permSelectAll__fEZDw`,
	"permSelectAllActive": `UserDetail_permSelectAllActive__JATnc`,
	"permEmpty": `UserDetail_permEmpty__fU3p6`,
	"listHead": `UserDetail_listHead__EFWFM`,
	"listTitle": `UserDetail_listTitle__eQQ7A`,
	"assignBtn": `UserDetail_assignBtn__cSW9z`,
	"searchBox": `UserDetail_searchBox__TCsa4`,
	"assignList": `UserDetail_assignList__9Kk2G`,
	"assignRow": `UserDetail_assignRow__LP7Ie`,
	"assignName": `UserDetail_assignName__ZXLCp`,
	"rowRight": `UserDetail_rowRight__c3Ne5`,
	"miniPill": `UserDetail_miniPill__qC2-H`,
	"pillActive": `UserDetail_pillActive__+0SFT`,
	"unassignBtn": `UserDetail_unassignBtn__2u2Y4`,
	"listEmpty": `UserDetail_listEmpty__VD48K`,
	"assignModalList": `UserDetail_assignModalList__uD2uX`,
	"assignSelectAll": `UserDetail_assignSelectAll__ebn3g`,
	"assignPickRow": `UserDetail_assignPickRow__QtNEW`,
	"assignCheck": `UserDetail_assignCheck__L1Q+q`,
	"assignCheckOn": `UserDetail_assignCheckOn__qZDAy`,
	"pwForm": `UserDetail_pwForm__tBiJC`,
	"pwField": `UserDetail_pwField__Mclny`,
	"pwError": `UserDetail_pwError__1iKj8`,
	"skTitle": `UserDetail_skTitle__mLXGk`,
	"skRounded": `UserDetail_skRounded__dRyIn`,
	"skBox": `UserDetail_skBox__5kmOY`,
	"skPermList": `UserDetail_skPermList__lUJgl`,
	"skPermRow": `UserDetail_skPermRow__T8blN`,
	"skRows": `UserDetail_skRows__I3FM1`,
	"skListRow": `UserDetail_skListRow__dro3k`
};
export default ___CSS_LOADER_EXPORT___;
